import { Message01Icon, Image01Icon } from "hugeicons-react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

export const UsageStats = () => {
  const { user, chatUsageData, imageUsageData, subscription } = useAuth();
  const navigate = useNavigate();
  if(!user || !chatUsageData) return null;

  const handlePricingClick = () => {
    navigate('/pricing');
  };
  
  // Calculate percentages, handling 'unlimited' and potential division by zero
  const chatPercentage = chatUsageData.total > 0 
    ? Math.min(100, (chatUsageData.used / chatUsageData.total) * 100) 
    : 0;
  
  // Calculate image percentage based on USED images
  const imagePercentage = (imageUsageData?.total ?? 0) > 0 
    ? Math.min(100, ((imageUsageData?.used ?? 0) / (imageUsageData?.total ?? 1)) * 100) 
    : 0;

  const chatDisplayText = `${chatUsageData.used}/${chatUsageData.total}`;
  const imageDisplayText = `${imageUsageData?.used || 0}/${imageUsageData?.total || 0}`;

  return (
    <div className="settings-item usage-stats">
      <h3>Usage Statistics</h3>

      {/* Chat Usage Bar */}
      <div className="usage-stat-item-wrapper">
        <div className="usage-stat-item">
          <div className="usage-icon-label">
            <Message01Icon size={18} className="usage-icon" />
            <span>Chats</span>
          </div>
          <div className="progress-bar-container" title={`${chatDisplayText} chats used`}>
            <div
              className="progress-bar-fill"
              style={{ width: `${chatPercentage}%` }}
              aria-valuenow={chatUsageData.used}
              aria-valuemin={0}
              aria-valuemax={chatUsageData.total}
              role="progressbar"
              aria-label="Chats Used"
            ></div>
          </div>
          <span className="usage-count">{chatDisplayText}</span>
        </div>
        <div className="usage-reset-time-wrapper"> 
          <span className="usage-reset-time">
            Resets on {chatUsageData.cycleEndDate ? new Date(chatUsageData.cycleEndDate).toLocaleString() : 'N/A'}
          </span>
        </div>
      </div>


      {/* Image Generation Usage Bar */}
      <div className="usage-stat-item-wrapper">
        <div className="usage-stat-item">
          <div className="usage-icon-label">
            <Image01Icon size={18} className="usage-icon" />
            <span>Images</span>
          </div>
          <div className="progress-bar-container" title={`${imageDisplayText} images used`}>
            <div
              className="progress-bar-fill"
              style={{ width: `${imagePercentage}%` }}
              aria-valuenow={imageUsageData?.used || 0}
              aria-valuemin={0}
              aria-valuemax={imageUsageData?.total || 0}
              role="progressbar"
              aria-label="Image Generations Used"
            ></div>
          </div>
          <span className="usage-count">{imageDisplayText}</span>
        </div>
        <div className="usage-reset-time-wrapper"> 
          <span className="usage-reset-time">
            Resets on {imageUsageData?.cycleEndDate ? new Date(imageUsageData.cycleEndDate).toLocaleString() : 'N/A'}
          </span>
        </div>
      </div>

      {/* Upgrade Button */}
      {subscription?.plan !== 'ultimate' && (
        <button onClick={handlePricingClick} className="usage-upgrade-button">
          Upgrade
        </button>
      )}
    </div>
  );
}; 